import { computeCmsResourceId } from './cmsContent.helpers';

export const dynamicNavbarContentEndpoint = '/api-exposer/headerStructure';

export const dynamicNavbarContentEndpointResourceId = computeCmsResourceId(
  dynamicNavbarContentEndpoint,
);
